import { useMemo } from "react";
import { customAPI } from "../services/api";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
const size = 1000000;

const getGroups = (token, page, filter, sort) =>
  customAPI(token)
    .get("api/Groups", {
      params: {
        size,
        page,
        companyId: filter?.companyId
          ? filter.companyId
          : "",
        orderBy:
          sort?.length && sort?.filter((i) => i.value)?.length
            ? `${sort.filter((i) => i.value).map((k) => `Fields/${k.subKey}`)}`
            : undefined,
        sort:
          sort?.length && sort?.filter((i) => i.value)?.length
            ? `${sort.filter((i) => i.value).map((k) => `${k.value}`)}`
            : undefined,
      },
    })
    .then((res) => res?.data?.data);

const normalizer = (items) => {
  const newItems = items?.map((item) => ({
    title: item?.displayName,
    id: item?.id,
    companyLookupId: item?.companyID,
  }));

  return newItems;
};

export const useCompanyGroupsAPI = ({ page = 1, enabled, sort, filter }) => {
  const { token } = useSelector((store) => store.auth);
  const { data, isLoading, refetch } = useQuery(
    [
      `GET-GROUPS-${filter}-${page}-${sort?.map((i) => `${i.key}-${i.value}`)}`,
      filter?.companyId,
    ],
    () => getGroups(token, page, filter, sort),
    {enabled:!enabled?false:true}
  );

  const normlizedData = useMemo(() => normalizer(data), [data]);

  return { data: normlizedData, isLoading, refetch };
};
